import script from "./PageReportEmployeessHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./PageReportEmployeessHouse.vue?vue&type=script&setup=true&lang=js"

import "./PageReportEmployeessHouse.vue?vue&type=style&index=0&id=638cf428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638cf428"]])

export default __exports__